import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import useApi from "../../hook/useApi";
import { toast } from "react-toastify";
import {
  copyToClipboard,
  formatDateInAMPM,
  trimAddress,
} from "../../utils/helper";
import "react-phone-input-2/lib/style.css";
import { IoCopyOutline } from "react-icons/io5";

const IcoTxViewLayer = () => {
  const [loading, setLoading] = useState(false);
  const [ico, setIco] = useState(null);
  const { id } = useParams();
  const { AsyncGetApiCall } = useApi();

  const fetchIco = async () => {
    setLoading(true);
    try {
      const result = await AsyncGetApiCall(`/private-sale/view?id=${id}`);
      console.log("result of fetchIco: ", result);

      if (result.errors) {
        toast.error(result.errors[0]);
      } else if (result.success) {
        setIco(result?.data);
      }
    } catch (error) {
      toast.error("An error occurred while fetching ICO details");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchIco();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="row gy-4">
        <div className="col-lg-8">
          {/* Top Right Card - ICO Data */}
          <div className="card mb-10">
            <div className="card-body p-24">
              <h5 className="mb-16">ICO Details</h5>
              <ul>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Id
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(ico?._id, 10, 8) || "N/A"}
                    {ico?._id && (
                      <button
                        onClick={() => copyToClipboard(ico?._id)}
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}>
                        <IoCopyOutline />
                      </button>
                    )}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Quantity
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.quantity || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Price Per Token
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.pricePerToken ? `${ico.pricePerToken} ETH` : "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Total Amount Paid
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.totalAmountPaid
                      ? `${ico.totalAmountPaid} ETH`
                      : "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Payment Currency
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.paymentCurrency || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Token Address
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(ico?.paymentTokenAddress, 10, 8) || "N/A"}
                    {ico?.paymentTokenAddress && (
                      <button
                        onClick={() =>
                          copyToClipboard(ico?.paymentTokenAddress)
                        }
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}>
                        <IoCopyOutline />
                      </button>
                    )}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Transaction Hash
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {trimAddress(ico?.txHash, 10, 8) || "N/A"}
                    {ico?.txHash && (
                      <button
                        onClick={() => copyToClipboard(ico?.txHash)}
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}>
                        <IoCopyOutline />
                      </button>
                    )}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    USD Rate at Purchase
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.usdRateAtPurchase || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Sale Stage
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.saleStage || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Status
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    <span
                      className={`badge ${
                        ico?.status === "pending"
                          ? "bg-warning-100 text-warning-600"
                          : ico?.status === "success"
                          ? "bg-success-100 text-success-600"
                          : "bg-danger-100 text-danger-600"
                      } text-sm py-4 px-10 radius-4`}>
                      {ico?.status.toUpperCase() || "N/A"}
                    </span>
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Created At
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.createdAt ? formatDateInAMPM(ico.createdAt) : "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-start gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Notes
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.notes || "N/A"}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Right Card - Buyer Info */}
          <div className="card">
            <div className="card-body p-24">
              <h5 className="mb-16">Buyer Info</h5>
              <ul>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Wallet Address
                  </span>
                  <span>:</span>
                  <div className="d-flex align-items-center w-70 text-secondary-light fw-medium">
                    <span>
                      {ico?.buyerInfo?.walletAddress
                        ? trimAddress(ico.buyerInfo.walletAddress, 10, 8)
                        : "N/A"}
                    </span>
                    {ico?.buyerInfo?.walletAddress && (
                      <button
                        onClick={() =>
                          copyToClipboard(ico.buyerInfo.walletAddress)
                        }
                        className="ms-3 p-0 border-0 bg-transparent"
                        style={{ lineHeight: 1 }}>
                        <IoCopyOutline />
                      </button>
                    )}
                  </div>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    Name
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.buyerInfo?.name || "N/A"}
                  </span>
                </li>
                <li className="d-flex align-items-center gap-2 mt-4">
                  <span className="w-30 text-md fw-semibold text-primary-light">
                    User Name
                  </span>
                  <span>:</span>
                  <span className="w-70 text-secondary-light fw-medium">
                    {ico?.buyerInfo?.userName
                      ? `@${ico.buyerInfo.userName}`
                      : "N/A"}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IcoTxViewLayer;
